import { Inject, Injectable } from '@angular/core';
import { NotificationProviderService, NotificationProviderTypeEnum } from './notification-provider.service';
import { ICartDetails } from '../interfaces/cart-details.interface';
import { CartDetailsSourceIdsEnum } from '../models/cartDetails/data-source-ids.enum';

declare const window: any;

export enum ExternalInterfacesEnum {
  CART_DETAILS = 'cartDetails',
}

@Injectable()
export class ExternalInterfacesService {
  private readonly delayRequestTime: number = 2000;

  constructor(
    @Inject('Endpoint') private endpoint: any,
    private notificationProviderService: NotificationProviderService,
  ) {
    this.notificationProviderService.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails && cartDetails.moreDataAvailable) {
        setTimeout(() => {
          this.updateCartDetails();
        }, this.delayRequestTime);
      }
    });
  }

  public getData(id: ExternalInterfacesEnum): object {
    const dataEl = document.getElementById(id) as HTMLElement;

    if (!dataEl) {
      return null;
    }

    const dataSource = dataEl.innerText.trim();

    if (dataSource.length) {
      const data = JSON.parse(dataSource);

      this.notify(id, data);

      return data;
    }

    return null;
  }

  public updateCartDetails(sourceId?: CartDetailsSourceIdsEnum, sourceToken?: string) {
    this.endpoint('newCart.cart', { pageNumber: window.STEP })
      .run()
      .then((response: ICartDetails) => {
        if (response) {
          if (sourceId) {
            response._sourceId = sourceId;
          }

          if (sourceToken) {
            response._sourceToken = sourceToken;
          }

          this.notify(ExternalInterfacesEnum.CART_DETAILS, response);
        }
      })
      .catch((error: any) => {
        console.error(error);
      });
  }

  private notify(id: ExternalInterfacesEnum, data: any) {
    for (const key in ExternalInterfacesEnum) {
      if (ExternalInterfacesEnum[key] === id && NotificationProviderTypeEnum[key]) {
        this.notificationProviderService.publish(NotificationProviderTypeEnum[key], data);

        break;
      }
    }
  }

}
